import { Loader, Result } from 'kiswe-ui'

export class Olympics {
  startDate: Date|null
  redirectURL: string|null
  athleteMomentBaseUrl: string|null

  constructor (data: unknown) {
    this.startDate = Loader.loadDateOrNull(data, 'startDate', null)
    this.athleteMomentBaseUrl = Loader.loadStringOrNull(data, 'athleteMomentBaseUrl', null)
    this.redirectURL = Loader.loadStringOrNull(data, 'redirectURL', null)
  }

  static load (data: unknown): Result<Olympics, 'invalid_params'|'unknown'> {
    try {
      return Result.success(new Olympics(data))
    } catch (error) {
      return Result.fromUnknownError('invalid_params', error)
    }
  }
}
